export enum ContextInstance {
    CbmImpl = "CbmImpl",
    AnalyticsImpl = "AnalyticsImpl",
    TwilsockAdapterImpl = "TwilsockAdapterImpl",
    TaskRouter = "TaskRouter",
    TwilioTelemetryProcessor = "TwilioTelemetryProcessor",
    TwilsockImpl = "TwilsockImpl",
    VoiceControllerImpl = "VoiceControllerImpl",
    FederatedAuthServiceImpl = "FederatedAuthServiceImpl",
    FlexUserServiceImpl = "FlexUserServiceImpl",
    ChannelNotesServiceImpl = "ChannelNotesServiceImpl",
    ErrorReporter = "ErrorReporter",
    LocalStorageImpl = "LocalStorageImpl",
    FeaturesServiceImpl = "FeaturesServiceImpl",
    AuthenticatorDataContainerImpl = "AuthenticatorDataContainerImpl",
    ClientOptionsStore = "ClientOptionsStore",
    ConfigurationServiceImpl = "ConfigurationServiceImpl",
    AuthenticatorImpl = "AuthenticatorImpl",
    ConversationsSdkImpl = "ConversationsSdkImpl",
    AccountConfigDataContainer = "AccountConfigDataContainer",
    PreviewOutboundServiceImpl = "PreviewOutboundServiceImpl",
    ClientImpl = "ClientImpl",
    LoggerConfigImpl = "LoggerConfigImpl",
    AccountConfigStore = "AccountConfigStore",
    SessionImpl = "SessionImpl",
    DataClientImpl = "DataClientImpl",
    TokenRegistry = "TokenRegistry",
    SsoSetupServiceImpl = "SsoSetupServiceImpl",
    TelemetryClientMock = "TelemetryClientMock"
}

export class ContextManager {
    readonly #instancePool: Map<ContextInstance, Object>;

    static newInstance() {
        return new ContextManager();
    }

    constructor() {
        this.#instancePool = new Map();
    }

    retrieveInstanceOf<T extends Object>(name: ContextInstance, Constructor: { new (t: ContextManager): T }): T {
        if (!this.#instancePool.has(name)) {
            this.#instancePool.set(name, new Constructor(this));
        }
        return this.#instancePool.get(name) as T;
    }

    





    setInstance<T extends Object>(instance: T, instanceName: ContextInstance): void {
        
        if (typeof global === "undefined" || !process.env) {
            throw new Error("setInstance is not meant to be used externally");
        }
        this.#instancePool.set(instanceName, instance);
    }

    destroy(): void {
        const iterator = this.#instancePool.entries();

        let isDone = false;
        while (!isDone) {
            const { value, done } = iterator.next();
            isDone = !!done;
            if (value) {
                const [, instance] = value;
                instance.destroy && instance.destroy();
            }
        }

        this.#instancePool.clear();
    }
}
